import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function generatePPIExcel({ entreprise, lignes, date }) {
  const resp = await fetch('/ppi_template.xlsx');
  const buf = await resp.arrayBuffer();

  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(buf);
  const ws = wb.getWorksheet(1);

  // Fill enterprise cells (into merged value areas)
  ws.getCell('B4').value = entreprise?.rc || '';
  ws.getCell('F4').value = entreprise?.tel || '';
  ws.getCell('B5').value = entreprise?.raisonSociale || '';
  ws.getCell('F5').value = entreprise?.email || '';
  ws.getCell('B6').value = entreprise?.nif || '';

  // Fill product lines starting row 11
  (lignes || []).forEach((l, i) => {
    const r = 11 + i;
    ws.getCell(`A${r}`).value = i + 1;
    ws.getCell(`B${r}`).value = l.position || '';
    ws.getCell(`C${r}`).value = l.sousPosition || '';
    ws.getCell(`D${r}`).value = l.designation || '';
    ws.getCell(`E${r}`).value = l.stock || '';
    ws.getCell(`F${r}`).value = l.quantite || '';
    ws.getCell(`G${r}`).value = l.unite || '';
    ws.getCell(`H${r}`).value = l.observations || '';
  });

  const outBuf = await wb.xlsx.writeBuffer();
  saveAs(new Blob([outBuf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `PPI_${date || 'export'}.xlsx`);
}
